module.exports = __webpack_public_path__ + "static/media/blueCTABackground.1d5d7506.webp";